export default {
    en: {
      global: {
        hello: 'Gps Tracking - Fleet Management',
        welcome: 'Welcome, {name}',
        yourLanguage: 'Your language is {name}',
        Language: 'Language',
        English: 'English',
        German: 'German',
        User: 'User',
        Reports: 'Reports',
        Administration: 'Administration',
        Logout: 'Logout',
        DateFrom: 'Date From',
        DateTo:	'Date To',
        LoginError: 'Wrong User Name or Password',
        AccountId: 'Account ID',
        UserName: 'User Name',
        Password: 'Password',
        TrackingLive: 'Tracking Live',
        TrackingHistory: 'Tracking History',
        MapSave: 'Save Map Settings',
        ChangeLanguage: 'Change Language',
        ChangeMap: 'Change Map Type',
        MapSatellite: 'Satellite Map',
        MapRoad:  'Road Map',
        MapSaveSettings:'Save Map Settings',
        Administration: 'Administration',
        Login: 'Login',
        AccountNumber: 'Account Number or Email',
        UserName: 'User Name or Email',
        Password: 'Password',
        PleaseCheckEntry: 'Please check your entries',
        Unit: 'Unit',
        DateTime: 'Date Time',
        Map: 'Map',
        Speed: 'Speed',
        Heading: 'Heading',
        Degree: 'Degree',
        IgnitionStatus: 'Ignition Status',
        On: 'On',
        Off: 'Off',
        IdleTime: 'Idle Time',
        StopTime: 'Stop Time',
        BatteryStatus: 'Battery Status',
        Hour: 'Hour',
        Minute: 'Minute',
        Second: 'Second',
        ShowTracks: 'Show Tracks',
        MapSaved: 'Map settings saved',
        ExportTracks: 'Export Tracks',
        Show: 'Show',
        Tracks: 'Tracks',
        Alerts: 'Alerts',
        Alert: 'Alert',
        Idles: 'Idle\'s',
        Stops: 'Stops',
        VehicleMaintenance: 'Vehicle Maintenance',
        MaintenanceGroup: 'Maintenance Group',
        MaintenanceGroups: 'Maintenance Groups',
        NewGroupOk: 'New group inserted',
        Edit: 'Edit',
        Delete: 'Delete',
        MaintenanceStatus: 'Maintenance Status',
        CreateSchedule: 'Create Schedule',
        DeleteThisGroup: 'Delete this group',
        Name: 'Name',
        AddNewGroup: 'Add New Group',
        EditGroupName: 'Edit Group Name',
        Save: 'Save',
        Cancel: 'Cancel',
        GroupDeleted: 'Group Deleted',
        GroupUpdated: 'Group Updated',
        SomethingWrong: 'Something Wrong',
        NewMaintenanceSchedule: 'New Maintenance Schedule',
        Description: 'Description',
        DistanceBased: 'Distance Based',
        TimeBased: 'Time Based',
        Repeat: 'Repeat',
        Once: 'Once',
        MaintenanceCreated: 'Maintenance schedules for {count} Vehicles were created',
        Status: 'Status',
        KmDue: 'Km Due',
        DayDue: 'Days Due',
        Begin: 'Begin',
        StartMeter: 'Start Meter',
        OdoMeter: 'Odo Meter',
        MarkSchedule: 'Mark {count} Schedule Entries as done?',
        Renew: 'Renew',
        RenewSchedule: 'Renew {count} Schedule Entries?',
        MarkDone: 'Mark as done',
        ShowMap: 'Show Map',
        MaintenanceRenewed: 'Maintenance plans for {count} vehicles have been renewed',
        MaintenanceMarkedDone: 'Maintenance plans for {count} vehicles have been marked as done',
        NewAlert: 'New Alert',
        Type: 'Type',
        ProcessAlerts: 'Process Alerts',
        GeofenceName: 'Geofence Name',
        AlertProcessed: 'Alert has been processed',
        AlertsProcessed: 'All open alerts have been processed',
        Comment: 'Comment',
        SaveCommentMarkLoad: 'Save Comment, Mark as Processed, Load Next',
        SaveCommmentMarkAll: 'All Pending Alerts: Save Comment and Mark as Processed',
        AudioAlertOn: 'Audio Alert On',
        Traffic: 'Traffic',
        PhoneNumber: 'SIM Card Number',
        Generated: 'Generated',
        Sent: 'Sent',
        By: 'By',
        Command: 'Command',
        SendNewCommand: 'Send new command',
        Enable: 'Enable',
        Disable: 'Disable',
        StartTracking: 'Start Tracking',
        EndTracking: 'End Tracking',
        Speak: 'Speak',
        SpeakText: 'Speak: text here',
        SendCommand: 'Send Command',
        NotAssigned: 'Not Assigned',
        Updated: 'Updated',
        TrackingGroup: 'Tracking Group',

        Milestone: 'Milestone',
        GenerateNewMilestone: 'Generate new Milestone',
        NewMilestoneName: 'New Milestone Name',
        SelectAlert: 'Select Alert',
        SelectOwner: 'Select Owner',
        GoalBaseLine: 'Goal Base Line',
        Reduce: 'Reduce',
        Increase: 'Increase',
        Percent: 'Percent',
        ReductionOrAddition: 'Reduction or Addition',
        Month: 'Month',
        Week: 'Week',
        Xtimes: 'x times',
        StartingAt: 'Starting At',
        SelectMilestone: 'Select Milestone',
        Starting: 'Starting',
        Ending: 'Ending',
        Goal: 'Goal',
        Real: 'Real',
        MilestoneGenerated: 'Milestone Generated',
        DeleteMilestone: 'Delete Milestone',
        QuestionDeleteMilestone: 'Do you want to delete this milestone?',
        MilestoneDeleted: 'Milestone Deleted',
        MilestoneDetailDeleted: 'Milestone Detail Deleted',
        DeleteMilestoneDetail: 'Delete Milestone Detail',
        QuestionDeleteMilestoneDetail: 'Do you want to delete this milestone detail?',
        GenerateMilestoneWith: 'Generate Milestone with {nrDetails} Details',
        StrategyDashboard: 'Strategy Dashboard',
        Refresh: 'Refresh',
        Owner: 'Owner',
        Performance: 'Performance',
        AverageReduction: 'Average Reduction',
        TotalPerformance: 'Total Performance',
        StrategyCenter: 'Strategy Center',
        Dashboard: 'Dashboard',
        Milestones: 'Milestones',

        CommdandsSentToUnit: 'Commdands Sent to Unit',

        FleetStatus: "Fleet Status",
        Distance24Hours: "Distance 24 Hours",
        UnitGroup : "Unit / Group",
        Alerts24Hours: "Alerts 24 Hours",
        VehicleMaintenanceStatus: "Vehicle Maintenance Status",
        MaintenanceSchedule: "Maintenance Schedule",
        Moving: "Moving",
        Idle: "Idle",
        Stopped: "Stopped",
        NotActive: "Not Active",
        NotActive3Day: "N/A 3 Days",
        DueDay: "Due Day",
        NumberOfUnits: "Number of Units",
        OverDue: "Over Due",
        ExcelAnalytics: "Excel - Analytics",
        AlertDashboard: "Alert Dashboard",
        DistanceDashboard: "Distance Dashboard",
        ExcelMobileMessage: "Excel Analytics builds on top of Excel Pivot Tables. Unfortunately they are not working well on the mobile versions of Excel. To use these features, please use a desktop web browser.",
        ExcelReports: "Excel Reports",
        DownloadExcel: "Download Excel",
        UploadExcelTemplate: "Upload new Excel Template",
        NewExcelReportName: "New Excel Report Name",
        ExcelTemplateDeleted: "Excel Template Deleted",
        DeleteExcelTemplate: "Delete Template",
        DeleteExcelTemplateQuestion: "Do you want to delete this this Excel Template?",
        UploadOk: "Template has been installed, it can be selected and executed now.",
        PoiDashboard: "POI Dashboard",
        Distance: "Distance",
        PointOfInterest: "Point of Interest",

        InstallExplain: "This app can be installed on your PC or mobile device. This will allow this web app to look and behave like any other installed app.",
        InstallHeader: "Install on your PC or Mobile Device",
        InstallButtonText: "Install as App",
        InstallIosInfotext: "Tap the share button and then 'Add to Homescreen'"
        
      }
    },
    de: {
      global: {
        hello: 'Gps Tracking - Flottenmanagement',
        welcome: 'Willkommen, {name}',
        yourLanguage: 'Ihre Sprache ist {name}',
        Language: 'Sprache',
        English: 'Englisch',
        German: 'Deutsch',
        User: 'Benutzer',
        Reports: 'Reports',
        Administration: 'Administration',
        Logout: 'Logout',
        DateFrom: 'Datum von',
        DateTo:	'Datum bis',
        LoginError: 'Benutzer Name oder Passwort nicht gültig',
        AccountId: 'Konto Nummer',
        UserName: 'Benutzer Name',
        Password: 'Passwort',
        TrackingLive: 'Live Tracking',
        TrackingHistory: 'Tracking Historisch',
        MapSave: 'Karte Einstellungen Speichern',
        ChangeLanguage: 'Sprache Aendern',
        ChangeMap: 'Karten Type Aendern',
        MapSatellite: 'Satelliten Karte',
        MapRoad:  'Strassen Karte',
        MapSaveSettings:'Karten Einstellungen Speichern',
        Administration: 'Verwalten',
        Login: 'Login',
        AccountNumber: 'Kunden Nummer oder Email',
        UserName: 'Benutzer Name oder Email',
        Password: 'Passwort',
        PleaseCheckEntry: 'Bitte überprüfen Sie Ihre Eingaben',
        Unit: 'Einheit',
        DateTime: 'Datum Zeit',
        Map: 'Karte',
        Speed: 'Geschwindigkeit',
        Heading: 'Richtung',
        Degree: 'Grad',
        IgnitionStatus: 'Zündungsstatus',
        On: 'Ein',
        Off: 'Aus',
        IdleTime: 'Leerlauf Zeit',
        StopTime: 'Stop Zeit',
        BatteryStatus: 'Batteriestatus',
        Hour: 'Stunde',
        Minute: 'Minute',
        Second: 'Sekunde',
        ShowTracks: 'Tracks anzeigen',
        MapSaved: 'Karten Einstellungen gespeichert',
        ExportTracks: 'Tracks Exportieren',
        Show: 'Anzeigen',
        Tracks: 'Tracks',
        Alerts: 'Alarme',
        Alert: 'Alarm',
        Idles: 'Leerlauf',
        Stops: 'Stop\'s',
        VehicleMaintenance: 'Fahrzeugwartung',
        MaintenanceGroup: 'Wartungsgruppe',
        MaintenanceGroups: 'Wartungsgruppen',
        NewGroupOk: 'Neue Gruppe eingefügt',
        Edit: 'Aendern',
        Delete: 'Löschen',
        MaintenanceStatus: 'Wartungsstatus',
        CreateSchedule: 'Zeitplan erstellen',
        DeleteThisGroup: 'Diese Gruppe löschen',
        Name: 'Name',
        AddNewGroup: 'Neue Gruppe Erfassen',
        EditGroupName: 'Gruppenname bearbeiten',
        Save: 'Speichern',
        Cancel: 'Abbrechen',
        GroupDeleted: 'Gruppe gelöscht',
        GroupUpdated: 'Gruppe aktualisiert',
        SomethingWrong: 'Etwas stimmt nicht',
        NewMaintenanceSchedule: 'Neuer Wartungsplan',
        Description: 'Beschreibung',
        DistanceBased: 'Entfernungs Basiert',
        TimeBased: 'Zeitbasiert',
        Repeat: 'Wiederholen',
        Once: 'Einmalig',
        MaintenanceCreated: 'Wartungspläne für {count} Fahrzeuge wurden erstellt',
        Status: 'Status',
        KmDue: 'Km Fällig',
        DayDue: 'Tage Fällig',
        Begin: 'Begin',
        StartMeter: 'Start Km',
        OdoMeter: 'Kilometerzähler',
        MarkSchedule: '{count} Wartungseinträge als erledigt markieren?',
        Renew: 'Erneuern',
        RenewSchedule: '{Count} Wartungseinträge erneuern?',
        MarkDone: 'Als erledigt markieren',
        ShowMap: 'Karte Zeigen',
        MaintenanceRenewed: 'Wartungspläne für {count} Fahrzeuge wurden erneuert',
        MaintenanceMarkedDone: 'Wartungspläne für {count} Fahrzeuge wurden als erledigt markiert',
        NewAlert: 'Neuer Alarm',
        Type: 'Typ',
        ProcessAlerts: 'Alarme Bearbeiten',
        GeofenceName: 'Geofence Name',
        AlertProcessed: 'Alarm als verarbeitet markiert',
        AlertsProcessed: 'Alle offenen Alarme wurden als verarbeited markiert',
        Comment: 'Komentar',
        SaveCommentMarkLoad: 'Kommentar speichern, als bearbeitet markieren, nächsten Alert anzeigen',
        SaveCommmentMarkAll: 'Alle offenen Alarme: Kommentar speichern, als bearbeitet markieren',
        AudioAlertOn: 'Audio Alarm eingeschaltet ',
        Traffic: 'Verkehr',
        PhoneNumber: 'SIM Card Nummer',
        Generated: 'Erstellt',
        Sent: 'Gesendet',
        By: 'Von',
        Command: 'Kommando',
        SendNewCommand: 'Neues Kommando Senden',
        Enable: 'Einschalten',
        Disable: 'Ausschalten',
        StartTracking: 'Begin Tracking',
        EndTracking: 'Enden Tracking',
        Speak: 'Sprechen',
        SpeakText: 'Speak: Text hier',
        SendCommand: 'Kommando Senden',
        NotAssigned: 'Nicht Zugeteilt',
        Updated: 'Aktualisiert',
        TrackingGroup: 'Tracking Gruppe',
        GenerateNewMilestone: 'Neuen Meilenstein Generieren',

        Milestone: 'Meilenstein',
        GenerateNewMilestone: 'Neuen Meilenstein Generieren',
        NewMilestoneName: 'Neuer Meilensteinname',
        SelectAlert: 'Alarm Wählen',
        SelectOwner: 'Verantworlich',
        GoalBaseLine: 'Zielbasislinie',
        Reduce: 'Reduzieren',
        Increase: 'Erhöhen',
        Percent: 'Prozent',
        ReductionOrAddition: 'Reduktion oder Erhöung',
        Month: 'Monat',
        Week: 'Woche',
        Xtimes: 'x mal',
        StartingAt: 'Beginnt',
        SelectMilestone: 'Meilenstein Wählen',
        Starting: 'Beginnt',
        Ending: 'Endet',
        Goal: 'Ziel',
        Real: 'Echt',
        MilestoneGenerated: 'Meilenstein generiert',
        DeleteMilestone: 'Meilenstein löschen',
        QuestionDeleteMilestone: 'Möchten Sie diesen Meilenstein löschen?',
        MilestoneDeleted: 'Meilenstein gelöscht',
        MilestoneDetailDeleted: 'Meilensteindetail gelöscht',
        DeleteMilestoneDetail: 'Meilensteindetail löschen',
        QuestionDeleteMilestoneDetail: 'Möchten Sie dieses Meilensteindetail löschen?',
        GenerateMilestoneWith: 'Generieren Sie einen Meilenstein mit {nrDetails} Details',
        StrategyDashboard: 'Strategie-Dashboard',
        Refresh: 'Aktualisieren',
        Owner: 'Verantwortlich',
        Performance: 'Performance',
        AverageReduction: 'Avg. Reduzierung',
        TotalPerformance: 'Total Performance',
        StrategyCenter: 'Strategiezentrum',
        Dashboard: 'Dashboard',
        Milestones: 'Meilensteine',

        CommdandsSentToUnit: 'Gesendete Befehle',
        ExcelAnalytics: "Excel - Analyse",
        AlertDashboard: "Alert Dashboard",
        DistanceDashboard: "Distanz Dashboard",
        ExcelMobileMessage: "Excel Analyse verwendet Excel-Pivot-Tabellen. Leider funktionieren diese in den mobilen Versionen von Excel nicht gut. Verwenden Sie bitte einen Desktop-Webbrowser um diese Funktionen zu verwenden.",
        ExcelReports: "Excel Berichte",
        DownloadExcel: "Download Excel",
        UploadExcelTemplate: "Neue Excel-Vorlage hochladen",
        FleetStatus: "Flotten Status",
        Distance24Hours: "Distanz 24 Stunden",
        Alerts24Hours: "Alerts 24 Stunden",

        UnitGroup : "Einheit / Gruppe",
        VehicleMaintenanceStatus: "Fahrzeug Wartungs Status",
        MaintenanceSchedule: "Wartungs Zeitplan",
        Moving: "Fahren",
        Idle: "Lehrlauf",
        Stopped: "Stop",
        NotActive: "Nicht Aktive",
        NotActive3Day: "N/A 3 Tage",
        DueDay: "Fällig Tag",
        NumberOfUnits: "Anzahl Einheiten",
        OverDue: "Über Fallig",
        NewExcelReportName: "Neuer Excel Report Name",
        ExcelTemplateDeleted: "Excel Vorlage Gelöscht",
        DeleteExcelTemplate: "Vorlage Löschen",
        DeleteExcelTemplateQuestion: "Wollen sie diese Excel Vorlage löschen?",
        UploadOk: "Die Vorlage wurde installiert und kann jetzt ausgewählt und ausgeführt werden.",
        PoiDashboard: "POI Dashboard",
        Distance: "Distanz",
        PointOfInterest: "Punkte von Interesse",

        InstallExplain: "Diese App kann auf Ihrem PC oder Mobilgerät installiert werden. Dadurch kann diese Web-App wie jede andere installierte App aussehen und sich verhalten.",
        InstallHeader: "Installieren Sie auf Ihrem PC oder Mobilgerät",
        InstallButtonText: "Als App installieren",
        InstallIosInfotext: "Tippen Sie auf die Schaltfläche 'Teilen' und dann auf 'Zum Homescreen hinzufügen'."
        
      }
    },
    es: {
      global: {
        hello: 'Rastreo Gps - Administración de Flotas',
        welcome: 'Bienvenido {name}',
        yourLanguage: 'Tu idioma es {name}',
        Language: 'Idioma',
        English: 'Inglés',
        German: 'Alemán',
        User: 'Usuario',
        Reports: 'Reportes',
        Administration: 'Administración',
        Logout: 'Salir',
        DateFrom: 'Fecha desde',
        DateTo:	'Fecha hasta',
        LoginError: 'Usuario o contraseña incorrectos',
        AccountId: 'ID',
        UserName: 'Usuario',
        Password: 'Contraseña',
        TrackingLive: 'Rastreo en vivo',
        TrackingHistory: 'Rastreo histórico',
        MapSave: 'Guardar configuración de mapa',
        ChangeLanguage: 'Cambiar idioma',
        ChangeMap: 'Cambiar tipo de mapa',
        MapSatellite: 'Mapa satelital',
        MapRoad:  'Mapa',
        MapSaveSettings:'Guardar configuración de mapa',
        Administration: 'Administración',
        Login: 'Iniciar sesion',
        AccountNumber: 'Número o email de cliente',
        UserName: 'Usuario o email',
        Password: 'Contraseña',
        PleaseCheckEntry: 'Por favor verifique sus datos',
        Unit: 'Unidad',
        DateTime: 'Fecha y hora',
        Map: 'Mapa',
        Speed: 'Velocidad',
        Heading: 'Titulo',
        Degree: 'Grado',
        IgnitionStatus: 'Estatus ignición',
        On: 'Encendido',
        Off: 'Apagado',
        IdleTime: 'Tiempo de ocio',
        StopTime: 'Tiempo detenido',
        BatteryStatus: 'Estatus bateria',
        Hour: 'Hora',
        Minute: 'Minuto',
        Second: 'Segundo',
        ShowTracks: 'Mostrar rastreo',
        MapSaved: 'Configuración de mapa guardado',
        ExportTracks: 'Export Tracks',
        Show: 'Show',
        Tracks: 'Rastreo',
        Alerts: 'Alertas',
        Alert: 'Alerta',
        Idles: 'Ocio',
        Stops: 'Paradas',
        VehicleMaintenance: 'Mantenimiento de vehículos',
        MaintenanceGroup: 'Grupo de mantenimiento',
        MaintenanceGroups: 'Grupos de mantenimiento',
        NewGroupOk: 'Nuevo grupo creado',
        Edit: 'Editar',
        Delete: 'Borrar',
        MaintenanceStatus: 'Estatus mantenimientos',
        CreateSchedule: 'Programar mantenimiento',
        DeleteThisGroup: 'Eliminar este grupo',
        Name: 'Nombre',
        AddNewGroup: 'Agregar nuevo grupo',
        EditGroupName: 'Editar el nombre del grupo',
        Save: 'Guardar',
        Cancel: 'Cancelar',
        GroupDeleted: 'Grupo eliminado',
        GroupUpdated: 'Grupo actualizado',
        SomethingWrong: 'Algo mal',
        NewMaintenanceSchedule: 'Nuevo programa de mantenimiento',
        Description:'Descripción',
        DistanceBased: 'Por Distancia',
        TimeBased: 'Por Tiempo',
        Repeat: 'Repetir',
        Once: 'Una vez',
        MaintenanceCreated: 'Se programó mantenimiento para {count} vehículos',
        Status: 'Estado',
        KmDue: 'Km Faltantes',
        DayDue: 'Días vencimiento',
        Begin: 'Fecha Inicio',
        StartMeter: 'Inicio km',
        OdoMeter: 'Cuentakilómetros',
        MarkSchedule: 'Marcar {count} mantenimientos realizados?',
        Renew: 'Renovar',
        RenewSchedule: '{Count} Renovar mantenimiento?',
        MarkDone: 'Realizado',
        ShowMap: 'Mostrar Mapa',
        MaintenanceRenewed: 'Se han renovado los planes de mantenimiento para {count} vehículos',
        MaintenanceMarkedDone: 'Los planes de mantenimiento para {count} vehículos han sido marcados como hechos',
        NewAlert: 'Nueva Alerta',
        Type: 'Tipo',
        ProcessAlerts: 'Procesar Alertas',
        GeofenceName: 'Nombre de Geocerca',
        AlertProcessed: 'La Alerta ha sido procesada',
        AlertsProcessed: 'Todas las alertas han sido procesadas',
        Comment: 'Comentario',
        SaveCommentMarkLoad: 'Guardar Comentario, Procesar Alerta y Cargar Siguiente',
        SaveCommmentMarkAll: 'Procesar Todas las Alertas y Guardar Comentario',
        AudioAlertOn: 'Sonido de Alerta Encendido',
        Traffic: 'Tráfico',
        PhoneNumber: 'Telefono SIM GPS',
        Generated: 'Generado',
        Sent: 'Enviado',
        By: 'Por',
        Command: 'Comando',
        SendNewCommand: 'Enviar nuevo comando',
        Enable: 'Habilitar',
        Disable: 'Deshabilitar',
        StartTracking: 'Iniciar Rastreo',
        EndTracking: 'Finalizar Rastreo',
        Speak: 'Hablar',
        SpeakText: 'Hablar: Escribir mensaje',
        SendCommand: 'Enviar Comando',
        NotAssigned: 'Not Assigned',
        Updated: 'Updated',
        TrackingGroup: 'Tracking Group',

        Milestone: 'Objetivo',
        GenerateNewMilestone: 'Crear nuevo Objetivo',
        NewMilestoneName: 'Nombre del nuevo Objetivo',
        SelectAlert: 'Selecciona Alerta',
        SelectOwner: 'Selecciona Usuario',
        GoalBaseLine: 'Inicio de medición',
        Reduce: 'Reducir',
        Increase: 'Aumentar',
        Percent: 'Porcentaje',
        ReductionOrAddition: 'Reducción o Aumento',
        Month: 'Mes',
        Week: 'Semana',
        Xtimes: '# veces',
        StartingAt: 'Iniciando en',
        SelectMilestone: 'Selecciona Objetivo',
        Starting: 'Inicio',
        Ending: 'Termino',
        Goal: 'Meta',
        Real: 'Real',
        MilestoneGenerated: 'Objetivo Creado',
        DeleteMilestone: 'Borrar Objetivo',
        QuestionDeleteMilestone: 'Quiere borrar este Objetivo?',
        MilestoneDeleted: 'Objetivo Borrado',
        MilestoneDetailDeleted: 'Mediciones del Objetivo Borradas',
        DeleteMilestoneDetail: 'Borrar Mediciones del Objetivo',
        QuestionDeleteMilestoneDetail: 'Quiere borrar las mediciones de este objetivo?',
        GenerateMilestoneWith: 'Crear Objetivo con {nrDetails} Mediciones',
        StrategyDashboard: 'Tablero Estratégico',
        Refresh: 'Actualizar',
        Owner: 'Usuario',
        Performance: 'Desempeño',
        AverageReduction: 'Reducción Promedio',
        TotalPerformance: 'Desempeño Total',
        StrategyCenter: 'Centro Estratégico',
        Dashboard: 'Tablero',
        Milestones: 'Objetivos',

        CommdandsSentToUnit: 'Commdands Sent to Unit',


        FleetStatus: "Estatus de Flota",
        Distance24Hours: "Distancia 24 Hrs.",
        UnitGroup : "Unidad / Grupo",
        Alerts24Hours: "Alertas 24 Hrs.",
        VehicleMaintenanceStatus: "Estatus Mantenimiento Vehículos",
        MaintenanceSchedule: "Programa de Mantenimientos",
        Moving: "Movimiento",
        Idle: "Ocio",
        Stopped: "Parou",
        NotActive: "No Activo",
        NotActive3Day: "N/Act 3 días",
        DueDay: "Vencimiento",
        NumberOfUnits: "Número de unidades",
        OverDue: "Atrasado",
        ExcelAnalytics: "Excel - Analítica",
        AlertDashboard: "Alerta Dashboard", 
        DistanceDashboard: "Distancia Dashboard",
        ExcelMobileMessage: "Excel Analítica se basa en las tablas dinámicas de Excel. Desafortunadamente no funcionan bien en las versiones móviles de Excel. Para usar estas funciones, utilice un navegador web de escritorio.",
        ExcelReports: "Informes de Excel",
        DownloadExcel: "Descargar Excel",
        UploadExcelTemplate: "Cargar nueva plantilla de Excel",
        NewExcelReportName: "Nuevo nombre de informe de Exce",
        ExcelTemplateDeleted: "Plantilla de Excel eliminado",
        DeleteExcelTemplate: "Eliminar plantilla",
        DeleteExcelTemplateQuestion: "Quieres eliminar esta plantilla de Excel?",
        UploadOk: "La plantilla se ha instalado, se puede seleccionar y ejecutar ahora.",
        PoiDashboard: "PDI Dashboard",
        Distance: "Distancia",
        PointOfInterest: "Punto de interés",

        InstallExplain: "Esta app puede ser instalada en tu PC o dispositivo móvil, podrás verla y usarla como cualquier otra aplicación instalada.",
        InstallHeader: "Instala en tu PC o dispositivo móvil",
        InstallButtonText: "Installar App",
        InstallIosInfotext: "Toque el botón compartir y luego 'Agregar a Pantalla de Inicio'"
      }
    },
    th: {
      global: {
        hello: 'ระบบ GPS เพื่อจัดการยานพาหนะ',
        welcome: 'ยินดีต้อนรับ, {name}',
        yourLanguage: 'ภาษาที่ต้องการคือ {name}',
        Language: 'ภาษา',
        English: 'อังกฤษ',
        German: 'เยอรมัน',
        User: 'ผู้ใช้งาน',
        Reports: 'รายงาน',
        Administration: 'การบริหารจัดการ',
        Logout: 'ออกจากระบบ',
        DateFrom: 'เริ่มจากวันที่',
        DateTo:	'ถึงวันที่',
        LoginError: 'ชื่อผู้ใช้งาน หรือ รหัสผ่าน ผิด',
        AccountId: 'ชื่อบัญชี',
        UserName: 'ชื่อผู้ใช้งาน',
        Password: 'รหัสผ่าน',
        TrackingLive: 'การติดตามแบบทันท่วงที',
        TrackingHistory: 'ประวัติการติดตาม',
        MapSave: 'บันทึกการตั้งค่าแผนที่',
        ChangeLanguage: 'เปลี่ยนภาษา',
        ChangeMap: 'เปลี่ยนประเภทแผนที่',
        MapSatellite: 'แผนที่ดาวเทียม',
        MapRoad:  'แผนที่เส้นทางถนน',
        MapSaveSettings:'บันทึกการตั้งค่าแผนที่',
        Administration: 'การบริหารจัดการ',
        Login: 'เข้าสู่ระบบ',
        AccountNumber: 'หมายเลขบัญชี',
        UserName: 'ชื่อผู้ใช้งาน หรือ อีเมลล์',
        Password: 'รหัสผ่าน',
        PleaseCheckEntry: 'กรุณาตรวจสอบอีกครั้ง',
        Unit: 'หน่วย',
        DateTime: 'วันที่ เวลา',
        Map: 'แผนที่',
        Speed: 'ความเร็ว',
        Heading: 'เส้นทาง',
        Degree: 'ระดับ',
        IgnitionStatus: 'สถานะการจุดระเบิด',
        On: 'เปิด',
        Off: 'ปิด',
        IdleTime: 'ช่วงเวลาที่เครื่องยนต์ทำงานแต่ไม่มีการเคลื่อนที่',
        StopTime: 'ช่วงเวลาที่ยานพาหนะจอด',
        BatteryStatus: 'สถานะแบตเตอรี่',
        Hour: 'ชั่วโมง',
        Minute: 'นาที',
        Second: 'วินาที',
        ShowTracks: 'แสดงผลการติดตาม',
        MapSaved: 'บันทึกการตั้งค่าแผนที่',
        ExportTracks: 'เรียกดูผลการติดตาม',
        Show: 'แสดง',
        Tracks: 'การติดตาม',
        Alerts: 'การแจ้งเตือน',
        Alert: 'การแจ้งเตือน',
        Idles: 'เครื่องยนต์ทำงานในขณะรถจอด',
        Stops: 'จุดที่รถหยุด',
        VehicleMaintenance: 'การซ่อมบำรุงยาพาหนะ',
        MaintenanceGroup: 'กลุ่มซ่อมบำรุง',
        MaintenanceGroups: 'กลุ่มการซ่อมบำรุง',
        NewGroupOk: 'เพิ่มกลุ่มใหม่เรียบร้อยแล้ว',
        Edit: 'แก้ไข',
        Delete: 'ลบ',
        MaintenanceStatus: 'สถานะการซ่อมบำรุง',
        CreateSchedule: 'วางแผนการซ่อมบำรุง',
        DeleteThisGroup: 'แจ้งลบกลุ่ม',
        Name: 'ชื่อ',
        AddNewGroup: 'เพิ่มกลุ่มใหม่ ',
        EditGroupName: 'แก้ไขชื่อกลุ่ม',
        Save: 'จัดเก็บ',
        Cancel: 'ยกเลิก',
        GroupDeleted: 'ลบกลุ่มเรียบร้อยแล้ว',
        GroupUpdated: 'อัพเดทกลุ่มเรียบร้อยแล้ว',
        SomethingWrong: 'เกิดข้อผิดพลาด',
        NewMaintenanceSchedule: 'กำหนดการใหม่สำหรับการซ่อมบำรุง',
        Description: 'รายละเอียด',
        DistanceBased: 'อ้างอิงตามระยะทาง',
        TimeBased: 'อ้างอิงตามเวลา',
        Repeat: 'ทำซ้ำ',
        Once: 'ครั้งนึง',
        MaintenanceCreated: 'ตารางการซ่อมบำรุงสำหรับยานพาหนะจำนวน {count} คัน ได้ถูกจัดทำเรียบร้อยแล้ว',
        Status: 'สถานะ',
        KmDue: 'กม. ครบกำหนด',
        DayDue: 'วันครบกำหนด',
        Begin: 'เริ่มต้น',
        StartMeter: 'เริ่มมิเตอร์',
        OdoMeter: 'เครื่องวัดระยะทาง',
        MarkSchedule: 'ใส่เครื่องหมาย {count} อัน ว่าเรียบร้อยแล้ว',
        Renew: 'ต่ออายุ',
        RenewSchedule: 'ต่ออายุ {count} กำหนดการ',
        MarkDone: 'การทำเครื่องหมายว่าเรียบร้อยแล้ว',
        ShowMap: 'แสดงแผนที่',
        MaintenanceRenewed: 'แผนการซ่อมบำรุงรักษายาพาหนะจำนวน {count} คัน ได้ถูกต่ออายุเรียบร้อยแล้ว',
        MaintenanceMarkedDone: 'การซ่อมบำรุงรักษายาพาหนะจำนวน {count} คัน ได้ถูกดำเนินการเรียบร้อยแล้ว',
        NewAlert: 'การแจ้งเตือนใหม่',
        Type: 'ประเภท',
        ProcessAlerts: 'กระบวนการ การแจ้งเตือน',
        GeofenceName: 'ชื่อของพื้นที่ ที่กำหนด',
        AlertProcessed: 'การแจ้งเตือนถูกประมวลผลเรียบร้อยแล้ว',
        AlertsProcessed: 'การแจ้งเตือนที่เปิดอยู่ทั้งหมดได้รับการประมวลผลแล้ว',
        Comment: 'คอมเมนต์',
        SaveCommentMarkLoad: 'บันทึกคอมเมนต์, เรียบร้อยแล้ว, โหลดอันถัดไป',
        SaveCommmentMarkAll: 'การแจ้งเตือนทั้งหมด: จัดเก็บคอมเมนต์และทำสัญลักษณ์ว่าเรียบร้อยแล้ว',
        AudioAlertOn: 'เปิดเสียงสำหรับการแจ้งเตือน',
        TrackingGroup: 'กลุ่มที่ติดตาม',
        Traffic: 'Traffic',
        PhoneNumber: 'SIM Card Number',
        Generated: 'Generated',
        Sent: 'Sent',
        By: 'By',
        Command: 'Command',
        SendNewCommand: 'Send new command',
        Enable: 'Enable',
        Disable: 'Disable',
        StartTracking: 'Start Tracking',
        EndTracking: 'End Tracking',
        Speak: 'Speak',
        SpeakText: 'Speak: text here',
        SendCommand: 'Send Command',
        NotAssigned: 'Not Assigned',
        Updated: 'Updated',
        GenerateNewMilestone: 'Generate new Milestone',

        Milestone: 'Milestone',
        GenerateNewMilestone: 'Generate new Milestone',
        NewMilestoneName: 'New Milestone Name',
        SelectAlert: 'Select Alert',
        SelectOwner: 'Select Owner',
        GoalBaseLine: 'Goal Base Line',
        Reduce: 'Reduce',
        Increase: 'Increase',
        Percent: 'Percent',
        ReductionOrAddition: 'Reduction or Addition',
        Month: 'Month',
        Week: 'Week',
        Xtimes: 'x times',
        StartingAt: 'Starting At',
        SelectMilestone: 'Select Milestone',
        Starting: 'Starting',
        Ending: 'Ending',
        Goal: 'Goal',
        Real: 'Real',
        MilestoneGenerated: 'Milestone Generated',
        DeleteMilestone: 'Delete Milestone',
        QuestionDeleteMilestone: 'Do you want to delete this milestone?',
        MilestoneDeleted: 'Milestone Deleted',
        MilestoneDetailDeleted: 'Milestone Detail Deleted',
        DeleteMilestoneDetail: 'Delete Milestone Detail',
        QuestionDeleteMilestoneDetail: 'Do you want to delete this milestone detail?',
        GenerateMilestoneWith: 'Generate Milestone with {nrDetails} Details',
        StrategyDashboard: 'Strategy Dashboard',
        Refresh: 'Refresh',
        Owner: 'Owner',
        Performance: 'Performance',
        AverageReduction: 'Average Reduction',
        TotalPerformance: 'Total Performance',
        StrategyCenter: 'Strategiezentrum',
        Dashboard: 'Dashboard',
        Milestones: 'Meilensteine',
        CommdandsSentToUnit: 'Commdands Sent to Unit',
        ExcelAnalytics: "Excel - Analytics",
        AlertDashboard: "Alert Dashboard",
        DistanceDashboard: "Distance Dashboard",
        ExcelMobileMessage: "Excel Analytics builds on top of Excel Pivot Tables. Unfortunately they are not working well on the mobile versions of Excel. To use these features, please use a desktop web browser.",
        ExcelReports: "Excel Reports",
        DownloadExcel: "Download Excel",
        UploadExcelTemplate: "Upload new Excel Template",
        NewExcelReportName: "New Excel Report Name",
        ExcelTemplateDeleted: "Excel Template Deleted",
        DeleteExcelTemplate: "Delete Template",
        DeleteExcelTemplateQuestion: "Do you want to delete this this Excel Template?",
        UploadOk: "Template has been installed, it can be selected and executed now.",
        PoiDashboard: "POI Dashboard",
        Distance: "Distanz",
        PointOfInterest: "Punkte von Interesse",

        InstallExplain: "This app can be installed on your PC or mobile device. This will allow this web app to look and behave like any other installed app.",
        InstallHeader: "Install on your PC or Mobile Device",
        InstallButtonText: "Install as App",
        InstallIosInfotext: "Tap the share button and then 'Add to Homescreen'"


      }
    }
  }